
/**
 * 검색어 (선택적)
 */
export type QueryParamParameter = string;
